import styled from 'styled-components';

export const DataTable = styled.table`
  th {
    background-color: #ececec;
    padding: 12px 16px;
    text-align: left;
    vertical-align: middle;
  }
  th:first-child {
    border-radius: 6px 0 0 0;
  }
  th:last-child {
    border-radius: 0 6px 0 0;
  }
  td {
    padding: 16px;
    width: 33%;
  }
  tbody {
    overflow: auto;
  }
  tbody tr:nth-child(even) {
    background-color: #fbfbfb;
  }
`;

export const TableLoaderCont = styled.div`
  border-radius: 4px;
  border: 1px #ddd solid;
  .body {
    padding: 30px;
  }
`;
